<template>
    <div class="slider-navigation" :class="classes">
        <button ref="prevElRef"
                type="button"
                class="slider-navigation__button _prev"
                :class="{ _disabled: isButtonPrevDisabled }"
        >
            <WBIcon name="chevron-left-thin" />
        </button>
        <button ref="nextElRef"
                type="button"
                class="slider-navigation__button _next"
                :class="{ _disabled: isButtonNextDisabled }"
        >
            <WBIcon name="chevron-right-thin" />
        </button>
    </div>
</template>

<script setup lang="ts">
    const props = withDefaults(defineProps<{
        isButtonPrevDisabled?: boolean
        isButtonNextDisabled?: boolean
        theme?: 'neutral' | 'indigo' | 'white'
    }>(), {
        theme: 'indigo'
    })

    const classes = computed(() => ({
        [`_theme-${props.theme}`]: props.theme
    }))

    const prevElRef = ref<HTMLElement>()
    const nextElRef = ref<HTMLElement>()

    defineExpose({
        prevEl: prevElRef,
        nextEl: nextElRef,
    })
</script>

<style scoped lang="scss">
    .slider-navigation {
        $this: &;

        display: flex;
        align-items: center;

        &._theme {
            &-indigo {
                --navigation-button-color: var(--indigo-200);
            }

            &-neutral {
                --navigation-button-color: var(--neutral-100);
            }

            &-white {

                #{$this} {
                    &__button {
                        --navigation-button-color: rgb(255 255 255 / 90%);

                        color: var(--blue-600);

                        &._disabled {
                            --navigation-button-color: rgb(255 255 255 / 30%);

                            color: var(--white);
                        }
                    }
                }
            }
        }

        &__button {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background-color: var(--navigation-button-color);
            font-size: 16px;
            color: var(--indigo-900);
            transition:
                color 0.2s ease,
                background-color 0.2s ease;
            cursor: pointer;

            @include hover {
                &:not(._disabled) {
                    background-color: var(--white);
                    color: var(--blue-500);
                }
            }

            &:not(:last-child) {
                margin-right: 12px;
            }

            &._disabled {
                opacity: 0.7;
            }
        }
    }
</style>
